// src/routes/ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Put the scroll inside a small timeout:
    setTimeout(() => {
      window.scrollTo(0, 0);
      console.log("coucou scroller")
    }, 0);
  }, [pathname]);

  return null;
}